import useTranslation from 'next-translate/useTranslation';
import { RemoveIcon } from 'public/svg/IconsSvg';

type RemoveCartItemButtonProps = {
    onItemRemove?: () => void;
    'data-testid'?: string;
    productName: string;
};

const RemoveCartItemButton: FC<RemoveCartItemButtonProps> = ({
    onItemRemove,
    'data-testid': testIdentifier,
    productName,
}) => {
    const { t } = useTranslation();

    return (
        <button
            aria-label={t('Remove from cart ' + productName)}
            type="button"
            className="cursor-pointer border-none bg-transparent text-[#bdbdbd] outline-none hover:text-primary"
            onClick={onItemRemove}
            data-testid={testIdentifier}
        >
            <RemoveIcon className="h-4 w-4 text-inherit" />
        </button>
    );
};

export default RemoveCartItemButton;
